// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"62db3215","455":"3fa5a7ef","977":"6b25ffa6"}[chunkId] + ".chunk.js";
};